export default {"src":"/_next/static/media/meal-icon.f8516e2b.svg","height":22,"width":23,"blurWidth":0,"blurHeight":0};